// extracted by mini-css-extract-plugin
module.exports = {"container":"text-editor_container__2pUmf","read-only":"text-editor_read-only__G2Tll","label":"text-editor_label__2wFXb"};